import { useState } from "react";
import { Box } from "@mui/system";
import FilterComponent from "../../../../ReusableFIlterComponent/FilterComponent";
import { STUCK_AT_LABELS } from "../utils/helpersOfBrands";

interface Props {
  rows: any[];
  selectedAffiliateSystem: string[] | null;
  setSelectedAffiliateSystem: (value: string[] | null) => void;
  selectedCompany: string[] | null;
  setSelectedCompany: (value: string[] | null) => void;
  selectedWebsite: string[] | null;
  setSelectedWebsite: (value: string[] | null) => void;
  selectedStuckAt: string[] | null;
  setSelectedStuckAt: (value: string[] | null) => void;
  selectedReason: string[] | null;
  setSelectedReason: (value: string[] | null) => void;
  clearFilters: () => void;
}

// Needs Configuration quick filters: Affiliate System / Company / Website /
// Stuck At / Reason, wired through the shared FilterComponent — same pattern
// as BrandsFilterItems.tsx (which supplies the identical Website filter to
// the All Brands tab).
const NeedsConfigurationFilterItems = ({
  rows,
  selectedAffiliateSystem,
  setSelectedAffiliateSystem,
  selectedCompany,
  setSelectedCompany,
  selectedWebsite,
  setSelectedWebsite,
  selectedStuckAt,
  setSelectedStuckAt,
  selectedReason,
  setSelectedReason,
  clearFilters,
}: Props) => {
  const [searchAffiliateSystem, setSearchAffiliateSystem] = useState("");
  const [searchCompany, setSearchCompany] = useState("");
  const [searchWebsite, setSearchWebsite] = useState("");
  const [searchStuckAt, setSearchStuckAt] = useState("");
  const [searchReason, setSearchReason] = useState("");

  const filterConfig = [
    {
      key: "AffiliateSystem",
      name: "Affiliate System",
      label: "Select one Affiliate System or more",
      searchTerm: searchAffiliateSystem,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchAffiliateSystem(e.target.value),
      selectedOption: selectedAffiliateSystem,
      filterName: "affiliate_system",
      data: rows,
      onSelectionChange: (updatedSelection: any) =>
        setSelectedAffiliateSystem(updatedSelection),
      count: selectedAffiliateSystem?.length ?? 0,
      colorSelected:
        selectedAffiliateSystem && selectedAffiliateSystem.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "Company",
      label: "Select one Company or more",
      searchTerm: searchCompany,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchCompany(e.target.value),
      selectedOption: selectedCompany,
      filterName: "company_name",
      data: rows,
      onSelectionChange: (updatedSelection: any) =>
        setSelectedCompany(updatedSelection),
      count: selectedCompany?.length ?? 0,
      colorSelected:
        selectedCompany && selectedCompany.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
      isLongText: true,
    },
    {
      key: "Website",
      name: "Website",
      label: "Select one Website or more",
      searchTerm: searchWebsite,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchWebsite(e.target.value),
      selectedOption: selectedWebsite,
      filterName: "website_name",
      data: rows,
      onSelectionChange: (updatedSelection: any) =>
        setSelectedWebsite(updatedSelection),
      count: selectedWebsite?.length ?? 0,
      colorSelected:
        selectedWebsite && selectedWebsite.length > 0 ? "#9C27B0" : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "StuckAt",
      name: "Stuck At",
      label: "Select a Stuck At",
      searchTerm: searchStuckAt,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchStuckAt(e.target.value),
      selectedOption: selectedStuckAt,
      filterName: "stuck_step",
      data: rows,
      onSelectionChange: (updatedSelection: any) =>
        setSelectedStuckAt(updatedSelection),
      count: selectedStuckAt?.length ?? 0,
      colorSelected:
        selectedStuckAt && selectedStuckAt.length > 0 ? "#9C27B0" : "#000000DE",
      multiSelect: true,
      showSearch: false,
      valueMapping: STUCK_AT_LABELS,
    },
    {
      key: "Reason",
      label: "Select a Reason",
      searchTerm: searchReason,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchReason(e.target.value),
      selectedOption: selectedReason,
      filterName: "reason",
      data: rows,
      onSelectionChange: (updatedSelection: any) =>
        setSelectedReason(updatedSelection),
      count: selectedReason?.length ?? 0,
      colorSelected:
        selectedReason && selectedReason.length > 0 ? "#9C27B0" : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
  ];

  return (
    <Box data-tracker="621">
      <FilterComponent filterConfig={filterConfig} clearFilters={clearFilters} />
    </Box>
  );
};

export default NeedsConfigurationFilterItems;
